module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  }, [_vm._v("Add New Client")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 3rem 1rem"
    }
  }, [_c('form', {
    attrs: {
      "id": "formValue"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Client Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.url),
      expression: "client.url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.client.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo",
      "id": "logo"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Client Logo') + "\n                  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Minimum size: width 200px * height 40px")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.firstName),
      expression: "client.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.lastName),
      expression: "client.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email),
      expression: "client.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.phone),
      expression: "client.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.client.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.userRole),
      expression: "client.userRole"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Role"
    },
    domProps: {
      "value": (_vm.client.userRole)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "userRole", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.password),
      expression: "client.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addClient()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.clients.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.clients), function(item, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#/teamInfo"
      }
    }, [_vm._v(_vm._s(item.companyName))])])]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [_c('button', {
      staticClass: "button is-primary is-small",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }, [_vm._v(" Edit")])])]), _vm._v(" "), _c('td', {
      staticClass: "is-icon",
      staticStyle: {
        "width": "30px"
      }
    }, [_c('button', {
      staticClass: "button is-danger is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteClient(item)
        }
      }
    }, [_vm._v(" Delete")])])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Edit Client")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 3rem 1rem"
    }
  }, [_c('form', {
    attrs: {
      "id": "formValue"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.companyName),
      expression: "onEditClient.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Client Name"
    },
    domProps: {
      "value": (_vm.onEditClient.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.websiteURL),
      expression: "onEditClient.websiteURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.onEditClient.websiteURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient, "websiteURL", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo2",
      "id": "logo2"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange2()
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.pictureName2 ? _vm.pictureName2 : 'Client Logo') + "\n                      ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.firstName),
      expression: "onEditClient.contactPerson.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.lastName),
      expression: "onEditClient.contactPerson.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.role),
      expression: "onEditClient.contactPerson.role"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Role"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.role)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "role", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.email),
      expression: "onEditClient.contactPerson.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onEditClient.contactPerson.phone),
      expression: "onEditClient.contactPerson.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.onEditClient.contactPerson.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.onEditClient.contactPerson, "phone", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editClient()
      }
    }
  }, [_vm._v("Save changes")])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Client(s)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                      upload logo\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "required": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("Client Name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                          upload a logo…\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379c9a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/changeVuAdmin/admin.vue
// module id = 368
// module chunks = 5